"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Damage = function Damage(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M21.5 3C21.5 2.86739 21.4473 2.74021 21.3536 2.64645C21.2598 2.55268 21.1326 2.5 21 2.5H3C2.86739 2.5 2.74021 2.55268 2.64645 2.64645C2.55268 2.74021 2.5 2.86739 2.5 3V21C2.5 21.1326 2.55268 21.2598 2.64645 21.3536C2.74021 21.4473 2.86739 21.5 3 21.5H21C21.1326 21.5 21.2598 21.4473 21.3536 21.3536C21.4473 21.2598 21.5 21.1326 21.5 21V3ZM20.5 16.3064L15.9222 14.7814L20.5 10.2066V16.3064ZM20.5 8.79281L15.2151 14.0745L11.6935 3.5H20.5V8.79281ZM14.0616 13.7757L3.5 6.73244V3.5H10.6395L14.0616 13.7757ZM3.5 7.93442L14.1312 15.0241L6.83333 20.5H3.5V7.93442ZM14.0168 16.36L12.6394 20.5H8.49944L14.0168 16.36ZM15.1479 16.128L18.0653 20.5H13.6933L15.1479 16.128ZM16.2214 15.9351L20.5 17.3604V20.5H19.2674L16.2214 15.9351Z",
    fill: props.foregroundColor
  }));
};

Damage.defaultProps = {
  altText: "Damage",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
Damage.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Damage;
exports.default = _default;